export class Search {

    constructor() {
        this.filter = document.getElementsByClassName('filter');

        if (this.filter && this.filter.length > 0) {
            this.form = document.getElementById('filter-form');
            this.filter = this.filter[0];
            this.addListeners();
            this.watchFormChanges();
        }
    }

    addListeners() {
        this.setCloseFilterButton();
        this.setShowFilterButton();
        this.clearFunctionality();
    }

    setCloseFilterButton() {
        const closeFilterButton = document.getElementsByClassName('close-filter');

        if (closeFilterButton && closeFilterButton.length > 0) {

            closeFilterButton[0].addEventListener('click', () => {

                if (this.filter) {
                    this.filter.style.display = 'none';
                }
            })
        }
    }

    setShowFilterButton() {
        const showFilterButton = document.getElementsByClassName('show-filter');

        if (showFilterButton && showFilterButton.length > 0) {

            showFilterButton[0].addEventListener('click', () => {

                if (this.filter) {
                    this.filter.style.display = 'block';
                }
            })
        }
    }

    watchFormChanges() {
        const inputs = document.getElementsByClassName('filter-input');

        if (inputs && inputs.length) {

            for (let i = 0; i < inputs.length; ++i) {
                inputs[i].addEventListener('change', () => {
                    this.form.submit();
                });
            }
        }
    }

    clearFunctionality() {
        const buttons = document.getElementsByClassName('clear-button');

        for (let i = 0; i < buttons.length; ++i) {

            buttons[i].addEventListener('click', (e) => {
                e.preventDefault();
                const group = e.target.getAttribute('data-group');

                let formElements = document.getElementsByClassName(group);

                for (let j = 0; j < formElements.length; ++j) {

                    if (group.indexOf('select') !== -1) {
                        formElements[j].selectedIndex = 0;
                    }

                    if (group.indexOf('check') !== -1) {
                        formElements[j].checked = false;
                    }
                }

                this.form.submit();
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/public/js/frontend/src/search/search.js